import { Pagination as MUIPagination } from '@mui/material';

import { PaginationProps } from './Pagination.interface';
import { PaginationFooterContainer } from './Pagination.styled';

export const Pagination = ({
  page,
  totalPages,
  onChange,
  loading,
  padding = '16px',
}: PaginationProps) => {
  return (
    <PaginationFooterContainer sx={{ padding }}>
      {!loading && (
        <MUIPagination
          count={totalPages}
          page={page}
          onChange={onChange}
          shape="rounded"
          showFirstButton
          showLastButton
        />
      )}
    </PaginationFooterContainer>
  );
};
